/** A required field's star: red while the field is empty, the label's own grey once it has a value (DS `FieldLabel requiredTone`). */
export function requiredTone(filled: unknown): 'error' | 'inherit' {
  const has = typeof filled === 'string' ? filled.trim().length > 0 : Boolean(filled);
  return has ? 'inherit' : 'error';
}
